import { createAsyncThunk } from "@reduxjs/toolkit";
import { CUSTOMER_AUTH_ROUTES } from "../../../constants/customerApiRoutes";
import { ILogin } from "../../../types/auth";
import API from "../../../services/axios";

interface ICustomerLogin {
  data: ILogin;
  callback: CallableFunction;
}

export const customerLogin = createAsyncThunk(
  CUSTOMER_AUTH_ROUTES.LOGIN,
  async ({ data, callback }: ICustomerLogin, { rejectWithValue }) => {
    try {
      const response = await API.post(CUSTOMER_AUTH_ROUTES.LOGIN, data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      return response?.data;
    } catch (error: any) {
      if (error?.response && error?.response?.data) {
        callback(
          error?.response?.data?.status,
          error?.response?.data?.data?.contact_number
        );
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);
